module.exports = __webpack_public_path__ + "img/m-3.94fcd64d.png";